var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"my-2"},[_c('a',{attrs:{"href":"#"}},[_c('img',{attrs:{"src":require("../../assets/logo.png")}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }